<template>
    <button
        @click="$emit('click', $event)"
        :type="type"
        :class="classes"
        :disabled="disabled"
        v-ripple
    >
        <v-font-icon :class="theme.icon">
            <slot></slot>
        </v-font-icon>
    </button>
</template>
<script>
    import { vFontIcon } from '../FontIcon';
    import { Ripple } from '../../directives';
    import theme from './iconButton.scss';

    export default {
        name: 'icon-button',
        props: {
            type: {
                type: String,
                default: 'button'
            },
            disabled: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        components: {
            vFontIcon,
        },
        computed: {
            classes() {
                return {
                    [this.theme.iconButton]: true,
                    [this.theme.isDisabled]: this.disabled,
                }
            },
        },
        directives: {
            Ripple,
        }
    }
</script>


// WEBPACK FOOTER //
// IconButton.vue?7ce14792